export const QUERY_KEYS = {
  User: ['user'] as const,
  OrganizationMembers: (params: {
    organizationId: string | null;
    [key: string]: string | number | boolean | null | undefined;
  }) => ['organizationMembers', params] as const,
} as const;
